module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"popular":"Самые популярные вопросы в этой теме","showMore":"Показать еще","questions":"вопросов | вопрос | вопроса | вопросов","hide":"Скрыть"}}')
  delete Component.options._Ctor
}
